import Vue from 'vue'
import App from './App.vue'
import i18n from './i18n'
import vuetify from './plugins/vuetify'
import router from './router'
import GlobalConfig, { loadConfig } from '@/GlobalSettings'

Vue.config.productionTip = false


import VueDragscroll from 'vue-dragscroll'
import store from "@/store";
Vue.use(VueDragscroll)
async function initial () {
  await loadConfig()
  i18n.locale=GlobalConfig.lang.toLowerCase()
  console.log("GlobalConfig", GlobalConfig)
  new Vue({
    i18n,
    vuetify,
    store,
    router,
    render: h => h(App)
  }).$mount('#app')

}

initial()

